import { render, staticRenderFns } from "./ListPresetFields.vue?vue&type=template&id=2f01adc0&scoped=true&"
import script from "./ListPresetFields.vue?vue&type=script&lang=js&"
export * from "./ListPresetFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f01adc0",
  null
  
)

export default component.exports